import React from 'react'
import { LinearProgress, Tooltip } from '@mui/material'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'

type Props = {
  minOrderPriceLimit: number
  // Montant manquant calculé par l'API (min_order_price_missing du groupe)
  missingAmount: number
}

const MinOrderPriceProgress: React.FC<Props> = ({ minOrderPriceLimit, missingAmount }) => {
  const message = `Plus que ${n(missingAmount)} pour atteindre le minimum d'achat de ${n(
    minOrderPriceLimit
  )}`

  const percentProgress = Math.round((1 - missingAmount / minOrderPriceLimit) * 100)

  return (
    <Tooltip title={message}>
      <div className="w-24 cursor-help">
        <div className="text-xs w-full flex items-center justify-center text-red-400">
          {missingAmount > 0 ? (
            <div className="flex items-center gap-2">
              <AssignmentLateIcon /> {n(missingAmount)}
            </div>
          ) : (
            'Minimum atteint'
          )}
        </div>

        <LinearProgress value={percentProgress} variant="determinate" color="error" />
      </div>
    </Tooltip>
  )
}

export default MinOrderPriceProgress
